import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import {ReactComponent as WrapArrow} from '../../assets/wrap-arrow.svg';
// import WrapArrow from '../../assets/wrap-arrow.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getRoutePhoto } from '../../redux/staticSlice';
import { VideoPlayer } from '../../components/VideoPlayer';
import { deleteRoutePhoto, rejectRoutePorch } from '../../redux/advertSlice';
import { formatTimestampToDayDate, getFullDateStringByStamp } from '../../helpers';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';


const getPopupTitle = (address, prom, porchId, index) => {
    const houseName = address.name;
    const porch = prom.isFullReport ? address.donePorches.find(p => p.id === porchId) : null;
    const porchNumber = porch && porch.id;
    const allFullReportContent = prom.isFullReport ? [...porch.photoUrls, porch.videoUrl] : null;
    const sendTime = prom.isFullReport ? allFullReportContent[index].time : address.donePorchUrls[index].time;
    const timestamp = +new Date(getFullDateStringByStamp(prom.city.UTC, sendTime));
    return `${houseName}${porchNumber ? `, Подъезд №${porchNumber}`:''} (${formatTimestampToDayDate(timestamp)})`;
}

export const AddressContentPopup = ({ closeFn, isFinishedRoute = false, isCurrentRoute, routeId, address, porchId, promoter, contentType = 'photos', content }) => {
    const outsideClickHandler = (evt) => {
        evt.target === evt.currentTarget && closeFn();
    };
    if (!content.length) {
        return null;
    }
    const {isFullReport} = promoter;
    const staticStorage = useSelector((state) => state.static);
    const imageStorage = staticStorage.photos.map(el => ({...el, staticType: 'photo'}));
    const videoStorage = staticStorage.videos.map(el => ({...el, staticType: 'video'}));

    const contentStorage = contentType === 'merged' ? [...imageStorage, ...videoStorage]
    : staticStorage[contentType].map(el => ({...el, contentType}))
    
    const dispatch = useDispatch();
    const [fileIndex, setFileIndex] = useState(0);

    const thisFile = contentStorage.find(file => file.name === content[fileIndex].fileName && file.type === content[fileIndex].type);
    const isPhoto = content[fileIndex].isPhoto;
    const isPhotoLoaded = !!thisFile;   //с видео thisFile не получаем

    useEffect(() => {
        content.forEach(file => {
            if (file.isPhoto) {
                dispatch(getRoutePhoto({type: file.type, name: file.fileName, promoterId: promoter._id, routeId}));
            }
        })
    }, [content]);

    const isNavEnabled = content.length > 1;
    const switchContentHandler = (nextDir) => {
        if (!isNavEnabled) return;
        if (nextDir) {
            if (fileIndex+1 > content.length-1) {
                setFileIndex(0);
                return;
            }
            setFileIndex(fileIndex+1);
            return;
        }
        if (fileIndex === 0) {
            setFileIndex(content.length-1);
            return;
        }
        setFileIndex(fileIndex-1);
    }
    const contentTitle = getPopupTitle(address, promoter, porchId, fileIndex);
    const missedCount = address.missedPorches.length;
    const photoReportRejectCount = !isFullReport ? address.donePorchUrls.filter(p => p.rejectComment).length : null;
    const isFullfilled = isFullReport ? !!(content.filter(c => c.isPhoto).length >= 2 && content.some(c => !c.isPhoto)) 
    : content.length === address.porchCount - missedCount + photoReportRejectCount;
    
    const [rejectText, setRejectText] = useState('');
    const setRejectTextHandler = (text) => {
        const z = rejectText ? ', ' : '';
        setRejectText(prev => `${prev + z + text}`)
    }

    const [rejectPhotoText, setRejectPhotoText] = useState(new Array(content.length).fill(''));
    const rejectPhotoTextHandler = (index, newVal) => {
        setRejectPhotoText(prev => prev.map((txt, i) => index === i ? newVal : txt));
    }
    const setRejectCommentHandler = (text, index) => {
        const z = rejectPhotoText[index] ? ', ' : '';
        setRejectPhotoText(prev => prev.map((txt, i) => index === i ? `${txt + z + text}` : txt))
    }
    const [rejectPorchNumber, setRejectPorchNumber] = useState(new Array(content.length).fill(''))
    const rejectPorchNumberHandler = (index, newVal) => {
        setRejectPorchNumber(prev => prev.map((num, i) => index === i ? +newVal : num));
    }
    const resetFunc = () => {
        if (isFullReport) {
            setRejectText('');
        } else {
            rejectPhotoTextHandler(fileIndex, '');
            rejectPorchNumberHandler(fileIndex, '')
        }
    }
    const [btnBlocked, blockBtn] = useState(false);
    const rejectHandler = (isReturn = false) => {
        blockBtn(true);
        const body = {
            promoterId: promoter._id,
            routeId,
            houseId: address.houseId,
            photoId: isFullReport ? null : content[fileIndex].fileName,
            porchId: isFullReport ? porchId : rejectPorchNumber[fileIndex] || null,
            isReturn,
            comment: isFullReport ? rejectText : rejectPhotoText[fileIndex]
        }
        dispatch(rejectRoutePorch({
            body,
            resetFunc,
            unblockBtn: () => blockBtn(false),
        }));
    }
    const thisPorch = isFullReport ? address.donePorches.find(p => p.id === porchId) : null;
    const isRejected = thisPorch ? thisPorch.rejectComment: address.donePorchUrls[fileIndex].rejectComment

    const thisRouteInfo = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === routeId);
    const isReady = !isFinishedRoute ? thisRouteInfo.readyToCheck : false;

    const Img = () => {

        const [zoom, setZoom] = useState(1);
        const [pos, setPos] = useState({x:0,y:0});
        const zoomStep = 0.2;
        const scrollStep = 35;
        const style = {
            transform: `scale(${zoom}, ${zoom}) translate(${pos.x}px, ${pos.y}px)`,
        }


        const wheelHandler = (evt) => {
            const multi = evt.deltaY > 0 ? -1 : 1;
            if (evt.ctrlKey) {
                if ( multi > 0 || (multi < 0 && zoom - zoomStep >= 0.2) ) {
                    setZoom(prev => prev + multi*zoomStep);
                }
                return;
            }
            if (zoom <= 1) return;
            if (evt.shiftKey) {
                setPos(prev => ({...prev, x: pos.x + multi*scrollStep}))
                return;
            }
            setPos(prev => ({...prev, y: pos.y + multi*scrollStep}))
        }


        return (
            <img style={style} onWheel={wheelHandler} src={thisFile.src} alt="" />
        )
    }

    const staticElement = isPhoto ? !isPhotoLoaded ? <div>Загрузка..</div> : <Img /> : <VideoPlayer routeId={routeId} promoterId={promoter._id} type={content[fileIndex].type} name={content[fileIndex].fileName} />

    const deletePhotoHandler = () => {
        dispatch(deleteRoutePhoto({
            promoterId: promoter._id,
            routeId,
            houseId: address.houseId,
            fileId: content[fileIndex].fileName,
        }))
    }
    return createPortal(
        <div className="popup-wrapper" onMouseDown={outsideClickHandler}>
            <div className='image-popup route-address-popup'>
                <div className='image-popup__image'>
                    <div className={`image-popup__nav prev ${isNavEnabled ? 'enabled' : ''}`} onClick={() => switchContentHandler(false)}><WrapArrow width={20} height={20}/></div>
                    <div className={`image-popup__nav next ${isNavEnabled ? 'enabled' : ''}`} onClick={() => switchContentHandler(true)}><WrapArrow width={20} height={20}/></div>
                    {staticElement}
                </div>
                <div className="image-popup__footer">
                    <div className="image-popup__info">
                        <span>{contentTitle}</span>
                        <span>
                            [{fileIndex+1}/{content.length}]
                            {!isFullfilled && <span style={{color: 'yellow'}}>(отправлен не полностью)</span>}
                        </span>
                    </div>
                    <div className="image-popup__reject">
                        {!isFinishedRoute && isReady && !isRejected && <div>
                            {!isFullReport && <span>Подъезд №:</span>}
                            {!isFullReport && <Input min={1} max={address.porchCount} type='number' value={rejectPorchNumber[fileIndex]} changeHandler={(e) => rejectPorchNumberHandler(fileIndex, e.target.value)} />}
                            {!isFullReport && <Input value={rejectPhotoText[fileIndex]} placeholder="Причина отклонения" changeHandler={(e) => rejectPhotoTextHandler(fileIndex, e.target.value)} />}
                            
                            {isFullReport && <Input value={rejectText} placeholder="Причина отклонения" changeHandler={(e) => setRejectText(e.target.value)} />}
                            
                            <Button text='+ дубль' onClick={isFullReport ? () => setRejectTextHandler('дубль') : () => setRejectCommentHandler('дубль', fileIndex)} />
                            <Button text='+ размытый контент' onClick={isFullReport ? () => setRejectTextHandler('размытый контент') : () => setRejectCommentHandler('размытый контент', fileIndex)} />
                        </div>}
                        {!!isRejected && <div>
                            <p style={{color:'#fb4a4a',fontWeight:'bold'}}>
                                {!isFullReport ? `Этот подъезд (№${address.donePorchUrls[fileIndex].id}) отклонен: `
                                : 'Этот подъезд отклонен: '} 
                                {isRejected}
                            </p>
                        </div>}
                        {!isFinishedRoute && <div>
                            <Button disabled={btnBlocked || !isReady} text={!isRejected ? 'Отклонить':'Принять'} onClick={!isRejected ? () => rejectHandler(false) : () => rejectHandler(true)}/>
                            {!isFullReport && isReady && content.length > address.porchCount - address.missedPorches.length && !!address.donePorchUrls[fileIndex].rejectComment &&<Button text='Удалить' onClick={deletePhotoHandler}/>}
                        </div>}
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById('popup-root'),
    );
};
